import React, { useState, useEffect } from 'react';
import { Plus } from 'lucide-react';
import { Button } from '../../components/ui/button';
import { Card, CardContent, CardHeader, CardTitle } from '../../components/ui/card';
import DataTable from '../../components/admin/DataTable';

const FeaturesManagement = () => {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);
  const [showForm, setShowForm] = useState(false);
  const [editing, setEditing] = useState(null);
  const [formData, setFormData] = useState({
    title_ar: '', description_ar: '', icon: 'CheckCircle', link_url: '', is_published: true
  });
  const BACKEND_URL = process.env.REACT_APP_BACKEND_URL || '';

  useEffect(() => { fetchItems(); }, []);

  const fetchItems = async () => {
    try {
      const response = await fetch(`${BACKEND_URL}/api/features/all`, {
        headers: { 'Authorization': `Bearer ${localStorage.getItem('token')}` },
      });
      setItems(await response.json());
    } catch (error) {
      console.error(error);
    } finally {
      setLoading(false);
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const url = editing ? `${BACKEND_URL}/api/features/${editing.id}` : `${BACKEND_URL}/api/features/`;
      const response = await fetch(url, {
        method: editing ? 'PUT' : 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${localStorage.getItem('token')}`,
        },
        body: JSON.stringify(formData),
      });
      if (response.ok) {
        fetchItems();
        resetForm();
        alert('تم الحفظ بنجاح');
      }
    } catch (error) {
      alert('حدث خطأ');
    }
  };

  const resetForm = () => {
    setFormData({ title_ar: '', description_ar: '', icon: 'CheckCircle', link_url: '', is_published: true });
    setEditing(null);
    setShowForm(false);
  };

  const columns = [
    { header: 'العنوان', accessor: 'title_ar' },
    { header: 'الأيقونة', accessor: 'icon' },
  ];

  return (
    <div className="space-y-6">
      <div className="flex justify-between items-center">
        <h1 className="text-3xl font-bold text-[#0F388E]">مميزات الجامعة</h1>
        <Button onClick={() => setShowForm(!showForm)} className="bg-[#0F388E]">
          <Plus className="ml-2" />إضافة ميزة
        </Button>
      </div>

      {showForm && (
        <Card>
          <CardHeader><CardTitle>{editing ? 'تعديل' : 'إضافة'} ميزة</CardTitle></CardHeader>
          <CardContent>
            <form onSubmit={handleSubmit} className="space-y-4">
              <input type="text" placeholder="العنوان *" value={formData.title_ar}
                onChange={(e) => setFormData({...formData, title_ar: e.target.value})}
                className="w-full px-4 py-2 border rounded-lg" required />
              <textarea placeholder="الوصف *" value={formData.description_ar}
                onChange={(e) => setFormData({...formData, description_ar: e.target.value})}
                className="w-full px-4 py-2 border rounded-lg" rows={3} required />
              <input type="url" placeholder="الرابط (اختياري)" value={formData.link_url}
                onChange={(e) => setFormData({...formData, link_url: e.target.value})}
                className="w-full px-4 py-2 border rounded-lg" />
              <select value={formData.icon} onChange={(e) => setFormData({...formData, icon: e.target.value})}
                className="w-full px-4 py-2 border rounded-lg">
                <option value="Globe">Globe - الاتفاقيات الدولية</option>
                <option value="Users">Users - أعضاء هيئة التدريس</option>
                <option value="BookOpen">BookOpen - البرامج الدراسية</option>
                <option value="Microscope">Microscope - المعامل</option>
                <option value="GraduationCap">GraduationCap - البيئة التعليمية</option>
                <option value="MapPin">MapPin - الموقع الجغرافي</option>
                <option value="FileText">FileText - توصيف البرامج</option>
                <option value="Library">Library - الخدمات الطلابية</option>
                <option value="CheckCircle">CheckCircle</option>
                <option value="Star">Star</option>
                <option value="Award">Award</option>
                <option value="Shield">Shield</option>
              </select>
              <div className="flex gap-3 justify-end">
                <Button type="button" variant="outline" onClick={resetForm}>إلغاء</Button>
                <Button type="submit">حفظ</Button>
              </div>
            </form>
          </CardContent>
        </Card>
      )}

      <Card>
        <CardContent className="pt-6">
          <DataTable columns={columns} data={items}
            onEdit={(item) => { setEditing(item); setFormData(item); setShowForm(true); }}
            onDelete={async (item) => {
              await fetch(`${BACKEND_URL}/api/features/${item.id}`, {
                method: 'DELETE',
                headers: { 'Authorization': `Bearer ${localStorage.getItem('token')}` },
              });
              fetchItems();
            }}
            loading={loading} />
        </CardContent>
      </Card>
    </div>
  );
};

export default FeaturesManagement;
